import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { formatProfitUsd } from '@/lib/format-profit';
import { DollarSignIcon } from 'lucide-react';
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from 'recharts';

interface ProfitsChartProps {
	data: { label: string; amount: number }[];
	title?: string;
}

const chartConfig = {
	amountUsd: { label: 'Профит', color: 'var(--chart-5)' },
};

export default function ProfitsChart({ data, title = 'Профиты' }: ProfitsChartProps) {
	const chartData = data.map(d => ({ ...d, amountUsd: d.amount / 100 }));
	const hasData = chartData.some(d => d.amountUsd > 0);

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-5/15 p-1.5'>
						<DollarSignIcon className='text-chart-5' size={16} />
					</div>
					<CardTitle className='text-sm'>{title}</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-2 py-3'>
				{!hasData ? (
					<div className='h-[180px] flex items-center justify-center text-sm text-muted-foreground'>Нет данных</div>
				) : (
					<ChartContainer config={chartConfig} className='h-[180px] w-full'>
						<AreaChart data={chartData} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
							<CartesianGrid strokeDasharray='3 3' vertical={false} />
							<XAxis dataKey='label' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} interval='preserveStartEnd' />
							<YAxis tickLine={false} axisLine={false} tick={{ fontSize: 10 }} tickFormatter={v => `$${v}`} />
							<ChartTooltip
								content={
									<ChartTooltipContent formatter={value => `$${formatProfitUsd(Number(value) * 100)}`} />
								}
							/>
							<Area type='monotone' dataKey='amountUsd' stroke='var(--chart-5)' fill='var(--chart-5)' fillOpacity={0.2} strokeWidth={2} />
						</AreaChart>
					</ChartContainer>
				)}
			</CardContent>
		</Card>
	);
}
